<h4 class="modal-title text-truncate">{{title}}</h4>
<kui-icon [name]="icon"
    class="ml-1"
    (click)="close.emit($event)"></kui-icon>